import { DestroyRef, Directive, HostBinding, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterLinkWithHref } from '@angular/router';
import { filter, tap } from 'rxjs/operators';

const activeRouteClassName = 'active';

@Directive({ selector: '[routerLink]' })
export class DefaultRouterLinkActiveDirective implements OnInit {
    private router = inject(Router);
    private routerLinkWithHref = inject(RouterLinkWithHref, { optional: true });
    private readonly destroyRef = inject(DestroyRef);

    @HostBinding(`class.${activeRouteClassName}`)
    protected active = false;

    public ngOnInit(): void {
        this.updateActive();

        this.router.events
            .pipe(
                filter((e) => e instanceof NavigationEnd),
                takeUntilDestroyed(this.destroyRef),
                tap(() => this.updateActive())
            )
            .subscribe();
    }

    private updateActive(): void {
        if (this.routerLinkWithHref) {
            this.active = this.router.isActive(this.routerLinkWithHref.urlTree, {
                paths: 'subset',
                queryParams: 'subset',
                fragment: 'ignored',
                matrixParams: 'ignored',
            });
        }
    }
}
